import { FeedbotThunk } from '../../../store/types'
import { isUnsavedSelector } from '../../../store/socketServer'
import { confirm } from '../../../lib/bootbox'
import { alertHavingUnsavedChanges } from '../utils/bootbox'
import { endpointHelpers } from '../endpointHelpers'
import { switchBot } from '../../../lib/navigation'

import { environmentGroupForCurrentBotSelector } from '../selectors/environmentGroupForCurrentBotSelector'

export const moveDevToProduction = (): FeedbotThunk => async (dispatch, getState) => {
  if (isUnsavedSelector(getState())) {
    return alertHavingUnsavedChanges()
  }
  const { prodId, prodName } = environmentGroupForCurrentBotSelector(getState())

  const isConfirmed = await confirm(`Do you really want to push current version to ${prodName}?`)
  if (!isConfirmed) {
    return
  }

  await dispatch(endpointHelpers.moveTestToProd.initiate()).unwrap()

  if (prodId) {
    switchBot(prodId)
  }
}
